export default class AdvancedMarker {
  constructor(map, point, index) {
    this.visible = true
    this.map = map
    this.point = point

    this.marker = this.createImageMarker({
      src: `${window.TEMPLATE_URI}/assets/images/markers/ico-marker-${index + 1}.svg`,
    })

    if (point.marker && point.marker.type == 'icon') {
      const defaultURL = `${window.TEMPLATE_URI}/assets/images/markers/ico-marker-default.svg`

      this.marker = this.createImageMarker({
        src: point.marker.url || defaultURL,
        width: point.marker.width,
        height: point.marker.height,
      })
    } else if (point.marker && point.marker.type == 'text') {
      this.marker = this.createTextMarker(point.title)
    }

    this.instance = new window.google.maps.marker.AdvancedMarkerElement({
      map: this.map,
      position: new window.google.maps.LatLng(
        this.point.position.lat,
        this.point.position.lng,
      ),
      title: this.point.title,
      content: this.marker,
      gmpClickable: true,
    })

    return this
  }

  show() {
    this.visible = true
    this.instance.setMap(this.map)
  }

  hide() {
    this.visible = false
    this.instance.setMap(null)
  }

  createImageMarker({ src, width = null, height = null }) {
    const element = document.createElement('img')
    element.src = src
    element.className = 'gmap-marker gmap-marker--image'

    if (width && height) {
      element.width = width
      element.height = height
    }

    return element
  }

  createTextMarker(text) {
    const element = document.createElement('div')
    const img = document.createElement('img')
    img.src = `${window.TEMPLATE_URI}/assets/images/icons/ico-info-blue.svg`
    img.width = 19
    img.height = 19

    element.appendChild(document.createTextNode(text))
    element.appendChild(img)
    element.className = 'gmap-marker gmap-marker--text'

    return element
  }
}
